import React from 'react';
import ExpenseContractRequestWorkspace from './ExpenseContractRequestWorkspace';

/** 계약의뢰접수 — 계약담당 접수/반려 */
export default function ExpenseContractRequestReceive() {
  return <ExpenseContractRequestWorkspace screenMode="receive" />;
}
